import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import firebase from "app/Auth";
import { AppDispatch } from "app/store";
import { Loading } from "common/elements";
import { MainLayout } from "features/layout";
import { PlayerPage } from "features/player";
import { AuthPageRoutes } from "features/auth";
import { AccountPage } from "features/account";
import { MessagePage } from "features/message";
import { getAccountUsers } from "features/account/api";
import { NotificationPage } from "features/notification";
import { useInitialApp } from "./useInitialApp";
import "react-toastify/dist/ReactToastify.css";

const StartupScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const auth = getAuth(firebase);
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // ユーザーがログイン済みの場合
        try {
          await dispatch(getAccountUsers({ uid: user.uid })).unwrap();
          navigate("/account");
        } catch (error) {
          console.error("Error fetching user:", error);
          navigate("/auth/login");
        }
      } else {
        // 未ログインの場合
        navigate("/auth/login");
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [dispatch, navigate]);

  if (loading) {
    return <Loading />;
  }

  return null;
};

export const AppIndexPage = () => {
  useInitialApp();

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Routes>
        <Route path="/">
          <Route index element={<StartupScreen />} />
          <Route path="auth/*" element={<AuthPageRoutes />} />
          <Route element={<MainLayout />}>
            <Route path="account" element={<AccountPage />} />
            <Route path="player" element={<PlayerPage />} />
            <Route path="message" element={<MessagePage />} />
            <Route path="notification" element={<NotificationPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" />} />
        </Route>
      </Routes>
    </>
  );
};
